import { axios } from '@/libs/api.request';
import { Response } from '@/types/request.d';
import { PayType } from '../config';

// 根据支付方式和优惠码
interface PackageMonthParams {
    coupon_code?: string;
    pay_type?: string;
    payment_channel_name?: string;
    balance_payment?: 0 | 1;
}

// 获取长期套餐信息
export const getPackageMonthInfo = (params: PackageMonthParams) => axios.request({
    url: '/sys/project/order/get-package-month-info',
    method: 'get',
    params,
    // data: {
    //     coupon_code: couponCode || '',
    // },
});

// 年付续费-获取套餐续费详情
export const getPackageRenewalInfo = (params: PackageMonthParams) => axios.request({
    url: '/sys/project/order/get-package-renewal-info',
    method: 'get',
    cancelDuplicateRequest: true,
    params,
});

interface BuyLongData {
    months: string;
    payType?: string;
    couponCode?: string;
}

// 续期（购买长期套餐）
export const buyLongTermPay = ({
    months,
    payType,
    couponCode,
}: BuyLongData) => {
    const data2: any = {
        coupon_code: '',
        months,
        pay_type: payType,
    };
    if (couponCode) {
        data2.coupon_code = couponCode;
    }

    return axios.request({
        url: '/sys/project/order/package-month',
        method: 'post',
        data: data2,
    });
};

export interface PackageRenewalOrderParams {
    pay_type: string;
    payment_channel_name?: string;
    input_return_address?: string;
    type: string;
    num: string;
    balance_payment?: 0 | 1;
    save_fast_payment?: '0' | '1'; // 保存快捷支付 0.否 1.是
    is_auto_renewal?: '0' | '1'; // 自动续费 0.否 1.是
    auto_renewal_email?: ''; // 通知邮箱
    currency: string; // 对公转账支付的币种
}
// 续期（购买长期套餐）
export const packageRenewalOrder = (data: PackageRenewalOrderParams) => axios.request({
    url: '/sys/project/order/package-renewal-order',
    method: 'post',
    data,
});

interface PackageInfoParams {
    package: string;
    user_num?: number;
    plugin_num?: number;
    page_num?: number;
    email_num?: number;
    label_num?: number;
    flow_num?: number;
    auto_reply_num?: number;
    ai_reply_num?: number;
    faq_num?: number;
    telegram_num?: number;
    translate_num?: number;
    instagram_num?: number;
    pay_type?: number;
    month_num?: number;
}

export interface PackageInfoRes {
    user_num: string;
    user_fee: string;
    plugin_num: string;
    plugin_fee: string;
    page_num: string;
    page_fee: string;
    telegram_num: string;
    telegram_fee: string;
    email_num: string;
    email_fee: string;
    label_num: string;
    label_fee: string;
    flow_num: string;
    flow_fee: string;
    auto_reply_num: string;
    auto_reply_fee: string;
    ai_reply_num: string;
    ai_reply_fee: string;
    faq_num: string;
    faq_fee: string;
    base_fee: string;
    extension_fee: string;
    all_fee: string;
    pay_money: string;
    one_month_fee: string;
}

// 获取套餐信息
export const getPackageInfo = (params: PackageInfoParams) => axios.request<Response<PackageInfoRes>>({
    url: '/sys/project/order/get-package-info',
    method: 'get',
    params,
});

export interface UpdatePackageParams {
    package: string;
    pay_type: string;
    user_num?: number;
    plugin_num?: number;
    page_num?: number;
    email_num?: number;
    label_num?: number;
    flow_num?: number;
    auto_reply_num?: number;
    ai_reply_num?: number;
    faq_num?: number;
    telegram_num?: number;
    translate_num?: number;
    instagram_num?: number;
    shop_id?: string;
}

export interface UpdatePackageRes {
    pay_url: string;
    money: string;
    currency_code: string;
    exchange_rate: string;
}

export const updatePackage = (data: UpdatePackageParams) => axios.request<Response<UpdatePackageRes>>({
    url: '/sys/project/order/update-package',
    method: 'post',
    data,
    customTips: true,
});

interface ShopListParams {
    source?: string; // 传shopify
}

export interface ShopListRes {
    id: string;
    marketing_shop_name: string;// 店铺名称
    marketing_icon_url?: string;// 店铺logo
    marketing_shop_url: string;// 店铺地址
    marketing_email?: string;// 店铺邮箱
    marketing_code?: string;// 店铺优惠码
    marketing_code_info?: string;// 店铺优惠码信息
    marketing_status?: string;// 完善信息状态（0 未完善， 1 已完善）
}

// 获取所有站点商店
export const getShopList = (params: ShopListParams) => axios.request<Response<ShopListRes>>({
    url: '/sys/project/marketing/get-shop-list',
    method: 'get',
    params,
});

interface GetPackagePreferentialInfoRes {
    common: {
        professional: string;
        commercial: string;
    };
    detail: {
        professional: {
            month: {
                [x: string]: string;
            };
            year: {
                [x: string]: string;
            };
        };
        commercial: {
            month: {
                [x: string]: string;
            };
            year: {
                [x: string]: string;
            };
        };
    };
}
// 获取套餐折扣优惠信息
export const getPackagePreferentialInfo = () => axios.request<Response<GetPackagePreferentialInfoRes>>({
    url: 'sys/project/order/get-package-preferential-info',
    method: 'get',
    cancelDuplicateRequest: true,
});

export interface AmountInfoParams {
    pay_type: string;
    payment_channel_name?: string;
    whatsapp_api_phone_money?: number;
    translate_num?: number;
    send_email_num?: number;
    whatsapp_balance?: number;
    money?: number;
    balance_payment?: 0 | 1;
}
interface AmountInfoRes {
    pay_money: string;
    fee: string;
    translate_money: string;
    send_email_money: string;
    original_money: string;
    wallet_pay_money: string;
    directly_pay_money: string;
    no_discount_pay_money: string;
}
// 获取购买额度金额信息
export const getAmountInfo = (params: AmountInfoParams) => axios.request<Response<AmountInfoRes>>({
    url: '/sys/project/order/get-amount-info',
    method: 'get',
    cancelDuplicateRequest: true,
    params,
});

interface PurchaseAmountParams {
    pay_type: string;
    input_return_address?: string;
    payment_channel_name?: string;
    translate_num?: number;
    send_email_num?: number;
    whatsapp_balance?: number;
    balance_payment?: 0 | 1;
    currency: string;
}
interface PurchaseAmountRes {
    pay_url: string;
    money: string;
    currency_code: string;
    exchange_rate: string;
}
// 购买额度
export const purchaseAmount = (data: PurchaseAmountParams) => axios.request<Response<PurchaseAmountRes>>({
    url: '/sys/project/order/purchase-amount',
    method: 'post',
    data,
});

interface PackageParams {
    package: string;
    user_num: number;
    channel_num: number;
    day_num: number;
    pay_type: string;
    payment_channel_name?: string;
    input_return_address?: string;
}

// 获取套餐信息(新)
export const packageInfo = (params: PackageParams) => axios.request<Response<any>>({
    url: '/sys/project/order/package-info',
    method: 'get',
    cancelDuplicateRequest: true,
    params,
});

interface ChangePackageRes {
    pay_url: string;
    currency_code: string;
    exchange_rate: string;
    money: string;
    client_secret: string;
    stripeToken: string;
    pay_type: string;
    address: string;
    code_photo: string;
    redirect_url?: string;
    balance_payment?: 0 | 1;
    pay_price?: string;
    pay_status?: string;
}

interface ChangePackageParams extends PackageParams {
    save_fast_payment?: '0' | '1'; // 保存快捷支付 0.否 1.是
    is_auto_renewal?: '0' | '1'; // 自动续费 0.否 1.是
    currency: string; // 对公转账选择的货币
}

export interface ChangePackageAgreement {
    save_fast_payment: '0' | '1'; // 保存快捷支付 0.否 1.是
    is_auto_renewal: '0' | '1'; // 自动续费 0.否 1.是
    auto_renewal_email: ''; // 通知邮箱
}

// 更改套餐（新）
export const changePackage = (data: ChangePackageParams) => axios.request<Response<ChangePackageRes>>({
    url: '/sys/project/order/change-package',
    method: 'post',
    data,
    customTips: true,
});

export interface OrderRechargeParams {
    encryption_session_id?: string;
    pay_type: string;
    money: string;
    currency: string;
    input_return_address?: string;
}

/**
 * 钱包余额充值
 * @param data
 */
export const orderRecharge = (data: OrderRechargeParams) => axios.request<Response<ChangePackageRes>>({
    url: '/sys/project/order/recharge',
    method: 'post',
    data,
});

export interface TransferReceiptParams {
    project_id: string,
    order_id: string,
    receipt_address: string
    company_name: string;
}

/**
 * 上传对公转账回执
 */
export const uploadCorporateTransferReceipt = (data: TransferReceiptParams) => axios.request<Response<any>>({
    url: '/sys/project/order/upload-corporate-transfer-receipt',
    method: 'post',
    data,
});

interface BindCardInfoRes extends ChangePackageAgreement {
    pay_type: PayType | '';
}

/**
 * 获取绑定信用卡情况
 */
export const getBindCardInfo = () => axios.request<Response<BindCardInfoRes>>({
    url: '/sys/project/order/get-bind-card',
    method: 'get',
    data: {},
});

/**
 * 绑定和解绑信用卡
 */
export const bindProjectCard = (data: ChangePackageAgreement) => axios.request<Response<{ url: string }>>({
    url: '/sys/project/order/bind-card',
    method: 'post',
    data,
});
